export default {
      id: "footer_contact-usage",
      viewBox: "0 0 18 13",
      url: "../dist/images/" + "sprite.svg#footer_contact-usage",
      toString: function () {
        return this.url;
      }
    }